// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608261620/js/" + chunkId + "." + {"44":"bd658daa","225":"22f5b7a2","481":"a13d67b0","486":"b6e9cbb2","770":"ea3a0a3a"}[chunkId] + ".0.059561108697100296.chunk.js";
};